import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { api, ApiError } from '../../api/http';
import { TextField } from '../../components/TextField';
import { t } from '../../i18n';
import { AuthLayout } from './AuthLayout';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api('/auth/forgot-password', { method: 'POST', body: { email }, anonymous: true });
      setSent(true);
    } catch (caught) {
      setError(
        caught instanceof ApiError && caught.status === 429
          ? t('auth.rateLimited')
          : t('auth.genericError'),
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout title={t('auth.forgotTitle')}>
      {sent ? (
        <p role="status" className="text-sm text-slate-700">
          {t('auth.forgotSent')}
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <p className="text-sm text-slate-600">{t('auth.forgotIntro')}</p>
          <TextField
            label={t('auth.email')}
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && (
            <p role="alert" className="text-sm text-red-700">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting || !email}
            className="w-full rounded bg-brand-700 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-900 disabled:opacity-50"
          >
            {t('auth.sendLink')}
          </button>
        </form>
      )}
      <p className="mt-4 text-center text-sm">
        <Link to="/login" className="text-brand-700 underline">
          {t('auth.backToSignIn')}
        </Link>
      </p>
    </AuthLayout>
  );
}
